import PropTypes from 'prop-types'

import { IntlProvider } from 'react-intl'
import { useRecoilState } from 'recoil'
import messages from '../i18n/messages.json'
import { localeSelector } from '../state/localeState'

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/locale-data/de') // Add locale data for de
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/locale-data/de') // Add locale data for de
}

const Locale = ({ children }) => {
  const [locale] = useRecoilState(localeSelector)

  return (
    <IntlProvider messages={messages[locale]} locale={locale} key={locale}>
      {children}
    </IntlProvider>
  )
}

Locale.propTypes = {
  children: PropTypes.node
}

export default Locale
